import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { notificationsApi } from 'APIServices/notifications/Notifications.api';
import {
    Notification,
    NotificationsResponse
} from 'utils/types/notifications/notifications.type';

export type NotificationData = Notification[][];

export enum ORDER_CONFIRMATION_STATUS {
    PENDING = 'Pending',
    CONFIRMED = 'Confirmed',
    REJECTED = 'Reject'
}

interface IInitialState {
    data: NotificationData;
    totalCount: number;
    loading: boolean;
}

const initialState: IInitialState = {
    data: [],
    totalCount: 0,
    loading: false
};

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        markAsRead() {
            // TODO making notifications as read is out of the scope and will be done in a separate ticket
        },
        markAllAsRead() {
            // TODO making notifications as read is out of the scope and will be done in a separate ticket
        },
        resetNotificationsState(state) {
            state.totalCount = initialState.totalCount;
            state.data = initialState.data;
            state.loading = initialState.loading;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            notificationsApi.endpoints.getNotifications.matchFulfilled,
            (state, { payload }: PayloadAction<NotificationsResponse>) => {
                state.data = [
                    ...state.data,
                    ...(payload.data
                        ? payload.data.items.map((item) => [item])
                        : [])
                ];
                state.totalCount = payload.data?.totalItemsCount || 0;
                state.loading = false;
            }
        );
        builder.addMatcher(
            notificationsApi.endpoints.getNotifications.matchPending,
            (state) => {
                state.loading = true;
            }
        );
        builder.addMatcher(
            notificationsApi.endpoints.getNotifications.matchRejected,
            (state) => {
                state.loading = false;
            }
        );
    }
});

export const { markAsRead, markAllAsRead, resetNotificationsState } =
    notificationsSlice.actions;
